import React from 'react';
import { formatInr } from './waStageLabels';

const ITEMS = [
  ['messages_today', 'Messages today', false],
  ['sessions_started', 'Sessions', false],
  ['bookings_completed', 'Bookings', false],
  ['revenue_inr', 'Revenue', true],
  ['new_registrations', 'Registrations', false],
  ['handoffs', 'Handoffs', false],
  ['abandonments', 'Abandoned', false],
];

export default function WaKpiGrid({ metrics, loading }) {
  const m = metrics || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      {ITEMS.map(([key, label, isMoney]) => (
        <div key={key} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
          <p className="text-xs text-gray-500 uppercase tracking-wide">{label}</p>
          <p className="text-xl font-bold text-[#1B375B] mt-1">
            {loading ? '—' : isMoney ? formatInr(m[key]) : (m[key] ?? 0)}
          </p>
        </div>
      ))}
    </div>
  );
}
